import { Component, OnInit, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-guest-sidenav-menu',
  templateUrl: './guest-sidenav-menu.component.html',
  styleUrls: ['./guest-sidenav-menu.component.scss']
})
export class GuestSidenavMenuComponent implements OnInit {
  @Output() sidenavClose = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }
  public onSidenavClose = () => {
    this.sidenavClose.emit();
  }
}
